import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import i18nService, { setDocumentLanguage, t } from '../../services/i18nService';
import sessionActions from '../../actions/SessionActions';
import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';

import styles from './options.scss';
import uiService from '../../services/UIService';
import TextToSpeechService from '../../services/TextToSpeechService';

class OptionsLanguageChooser extends React.Component {
    static propTypes = {
        setLanguage: PropTypes.func.isRequired,
        sessionLanguage: PropTypes.string.isRequired,
    };

    getLanguageChoices = () => {
        const availableLanguages = i18nService.getAvailableLanguages();

        return availableLanguages.map((insperaLanguageCode) => {
            const identifier = i18nService.getIetfLanguageCode(insperaLanguageCode);
            return {
                identifier,
                title: t(`options.languages.${identifier}`),
                isSelected: this.props.sessionLanguage === identifier,
                language: identifier.substring(0, 2),
            };
        });
    };

    handleLanguageChange = (language) => {
        setDocumentLanguage(language.substring(0, 2));
        TextToSpeechService.disableTTSIfUnavailable(language);
        i18nService.changeLanguage(language, (err) => {
            if (err) {
                return;
            }

            this.props.setLanguage(language);
            uiService.setDirection(language);
        });
    };

    render() {
        const choices = this.getLanguageChoices();

        return (
            <div>
                <OptionsTopBar title={t('options.language')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.handleLanguageChange}
                        choices={choices}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        sessionLanguage: state.session.language,
    };
}

const OptionsLanguage = connect(mapStateToProps, sessionActions)(OptionsLanguageChooser);
export default OptionsLanguage;
